'use strict';

angular.module('internal.applications')
    .controller('InternalApplicationsPreview', ['$scope', 'LicenseRequests', '$stateParams', '$rootScope', '$window', '$filter', 'FBResponses', 'PortalPermissions', 'Enterprise', function ($scope, LicenseRequests, $stateParams, $rootScope, $window, $filter, FBResponses, PortalPermissions, Enterprise) {
        $scope.review = $stateParams.review;
        $scope.loading = true;
        $scope.bulkActionApplications = [];
        $scope.showBulkAction = false;
        $scope.listParams = {
            currentPage: 0,
            numPerPage: 10
        }

        LicenseRequests.get({ userOnly: !$scope.review, reviewOnly: $scope.review, userID: $stateParams.userID }).then(function (applications) {
            if (applications != null) {
                $scope.applications = applications.records;
                getServiceApplicationVehicles();
            }
            $scope.loading = false;
        });

        PortalPermissions.getPermissions().then(function (portalPermissions) {
            if (portalPermissions && portalPermissions["portal.menus.reviewPayment"] && portalPermissions["portal.menus.reviewPayment"].visible) {
                $scope.showBulkAction = true;
            }
        })

        Enterprise.getLess({ isPortal: true }).then(function (enterprise) {
            if (enterprise != null) {
                $scope.enterprise = enterprise;
                $scope.serviceLabel = enterprise.serviceLabels["SERVICE"];

                // Get Vehicle entity fields (call sign, serial_number, unit_number)
                $scope.vehicle = {};
                var entityIdx = $scope.enterprise.entities.findIndex(function (item) {
                    return item.id === '774e4ce2-2d43-43fa-b64d-c70eb53e81ee'; // vehicles id in Entity_Enterprise_Fields
                });
                if (entityIdx !== -1) {
                    var categoryIdx = $scope.enterprise.entities[entityIdx].categories.findIndex(function (item) {
                        return item.id === 'ca1379c4-3660-4d31-9fda-d1ee60c7b807'; // details id in Entity_Categories
                    });
                    if (categoryIdx !== -1) {
                        const len = $scope.enterprise.entities[entityIdx].categories[categoryIdx].fields.length;
                        const fields = $scope.enterprise.entities[entityIdx].categories[categoryIdx].fields;

                        for (var i = 0; i < len; i++) {
                            if (fields[i].name === 'call_sign') {
                                $scope.vehicle.callSignName = fields[i].label;
                                $scope.vehicle.useCallSign = fields[i].public_portal;
                            } else if (fields[i].name === 'serial_number') {
                                $scope.vehicle.serialNumberName = fields[i].label;
                                $scope.vehicle.useSerialNumber = fields[i].public_portal;
                            } else if (fields[i].name === 'unit_number') {
                                $scope.vehicle.unitNumberName = fields[i].label;
                                $scope.vehicle.useUnitNumber = fields[i].public_portal;
                            }
                        }
                    }
                }
            }
        });

        $scope.listParams.currentPage = 0;
        $scope.listParams.numPerPage = 10;

        $scope.$watch('search', function (old, newie) {
            if (old != newie) {
                $scope.listParams.currentPage = 0;
            }
        });

        $scope.clear = function () {
            $scope.search = '';
            $scope.listParams.currentPage = 0;
        }

        $scope.greaterThan = function (prop, val) {
            return function (item) {
                return item[prop] > val;
            }
        }

        $scope.formCountText = function (application) {
            var total = 0;
            var completed = 0;

            if (application.packages != null && application.packages.length > 0) {
                application.packages.forEach(function (pack) {
                    if (pack.responses != null && pack.responses.length > 0) {
                        total += pack.responses.length;
                        completed += $filter('filter')(pack.responses, function (r) { return r.completed_On != null }).length;
                    }
                });
            }
            if (application.responses != null && application.responses.length > 0) {
                total += application.responses.length;
                completed += $filter('filter')(application.responses, function (r) { return r.completed_On != null }).length;
            }

            return completed + " of " + total + " completed";
        }

        $scope.viewPdf = function (response) {
            if ($rootScope.isPortal && $rootScope.isPortal == "True") {
                $window.open($rootScope.portalURL + 'controller.cfm?method=publicPortalService.openDocument' + '&documentID=' + response.document_id.toUpperCase() + '&code=' + response.document_code, '_blank');
            }
            else {
                $window.open($rootScope.internalURL + 'controller.cfm?method=publicPortalService.openDocument' + '&documentID=' + response.document_id.toUpperCase() + '&code=' + response.document_code, '_blank');
            }
        }

        function getServiceApplicationVehicles() {
            $scope.appLoading = true;
            var licenseRequestIds = [];

            // If there's a service, grab formIds to see if they have 'service_vehicles' data set
            if ($scope.applications) {
                for (var i = 0; i < $scope.applications.length; i++) {
                    if ($scope.applications[i].serviceId != null) {
                        licenseRequestIds.push($scope.applications[i].id);
                    }
                }

                (function () {
                    FBResponses.getServiceApplicationVehicles(licenseRequestIds).then(function (dataSet) {
                        if (dataSet != null) {
                            // Create a dictionary of license_request_id's & the vehicle_count
                            var licenseRequestsAndVehicles = dataSet.reduce(function (acc, data) {
                                if (acc[data.license_request_id]) {
                                    acc[data.license_request_id] += data.vehicle_count;
                                } else {
                                    acc[data.license_request_id] = data.vehicle_count;
                                }
                                return acc;
                            }, {});

                            for (var i = 0; i < dataSet.length; i++) {
                                // find index of application that needs vehicle data 
                                var applicationIdx = $scope.applications.findIndex(function (item) {
                                    return item.id === dataSet[i].license_request_id;
                                });

                                // If license_request_id is in dictionary, add vehicle data
                                if (licenseRequestsAndVehicles.hasOwnProperty(dataSet[i].license_request_id)) {
                                    $scope.applications[applicationIdx].vehicle = {};
                                    $scope.applications[applicationIdx].vehicle.vehicle_count = licenseRequestsAndVehicles[dataSet[i].license_request_id];
                                    if (dataSet[i].vehicle_count === 1) {
                                        $scope.applications[applicationIdx].vehicle.call_sign = dataSet[i].call_sign
                                        $scope.applications[applicationIdx].vehicle.serial_number = dataSet[i].serial_number
                                        $scope.applications[applicationIdx].vehicle.unit_number = dataSet[i].vehicle_unit_number
                                    }
                                }
                            }
                        }
                        $scope.appLoading = false;
                    });
                })(i);
            }
        }

        $scope.checkAllApplications = function (event, checkAll, applications) {
            event.stopImmediatePropagation();
            applications.forEach(function (application) {
                application.inBulkApply = checkAll;
                if (checkAll) {
                    //Add everything to bulk action if doesn't exist
                    if (!$scope.bulkActionApplications.includes(application.id)) {
                        $scope.bulkActionApplications.push(application.id);
                    }
                }
            })
            if (!checkAll) {
                //Clear everything
                $scope.bulkActionApplications = [];
            }
        };

        $scope.applyOne = function (event, application) {
            event.stopImmediatePropagation();
            if (application.inBulkApply) {
                //Add to bulk action list
                $scope.bulkActionApplications.push(application.id);
            } else {
                //Remove from bulk action list
                var index = $scope.bulkActionApplications.indexOf(application.id);
                $scope.bulkActionApplications.splice(index, 1);
            }
        };

        $scope.payApplications = function (bulkApply) {
            //Do nothing on preview
        };
    }])
    ;